/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import cn from 'classnames';
import { Button } from '@ui-elements';
import { money } from '~/common/utils';
import { OfferListing, OfferSash } from '~/common/models';
import styles from './index.module.scss';
import { TooltipDisclaimer } from '~/common/components/ui-elements';
import { OfferSashContent } from '../offer-main-card/offerSashContent';
import { DeviceType } from '../offer-listing/offerDeviceType';
import { LegalDisclaimerContent } from '../offer-main-card/legalDisclaimerContent';

interface SecondaryTileCardProps {
  offer: OfferListing;
  hideContent?: boolean;
  deviceType: DeviceType;
  layoutClass: string;
}

export const OfferSecondaryCard = ({
  offer,
  hideContent,
  deviceType,
  layoutClass,
}: SecondaryTileCardProps) => {
  const offerUrl = `/special-offers/${offer.uniqueName}`;
  const hasPrice = offer.price > 0;
  const mediaForDevice =
    offer.media?.find((m) => m.devices.includes(deviceType)) ||
    offer.media?.[0];
  const mediaThumbnail = offer.media?.find((m) => m.isThumbnail === true);

  return (
    <div
      className={cn(styles.secondaryTileCard, styles[layoutClass], {
        [styles.hoverable]: hideContent,
      })}
      onClick={() => window.open(offerUrl, '_self')}
    >
      <div className={styles.imageWrapper}>
        <img src={mediaForDevice?.url || ''} alt={offer.title} />
        <OfferSashContent sash={offer.sash} />
        <LegalDisclaimerContent
          disclaimer={mediaThumbnail}
          deviceType={deviceType}
        />
      </div>

      {!hideContent && (
        <div
          className={styles.secondaryTileContent}
          style={{
            color: `${offer.contentColor?.contentTextColor}` || 'inherit',
            background: offer.contentColor?.contentBackgroundColor || 'inherit',
          }}
        >
          <div className={styles.offerTitle}>
            <div
              className={styles.offerTitleText}
              dangerouslySetInnerHTML={{ __html: offer.title as string }}
            />
            {offer.titleDisclaimer && (
              <TooltipDisclaimer
                customContent
                disclaimer={offer.titleDisclaimer}
                triggerClassName={styles.disclaimerTrigger}
              />
            )}
          </div>

          {offer.blurb && (
            <div dangerouslySetInnerHTML={{ __html: offer.blurb }} />
          )}
          {offer.viewOfferText && (
            <Button className={styles.ctaButton} href={offerUrl}>
              {offer.viewOfferText}
              {hasPrice && (
                <span>
                  <sup>$</sup>
                  <span>{money(offer.price).replace('$', '')}</span>
                  <sup>*</sup>
                </span>
              )}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
